const login = async(phone, password) => {

    let url = `/api/login`;
    const response =  await fetch(url, {
        method: 'POST',
        body: JSON.stringify({"contactNumber": phone,"password": password}),
         headers: {
            'Content-Type': 'application/json',
        }
    });
    if (response.ok) {
        return await response.json();
        
    }
    throw response;
}

const register = async(phone, name) => {

    let url = `/api/register`;
    const response =  await fetch(url, {
        method: 'POST',
        body: JSON.stringify({"contactNumber": phone,"name": name}),
         headers: {
            'Content-Type': 'application/json',
        }
    });
    if (response.ok) {
        return await response.json();
        
    }
    throw response;
}

const verifyOtp = async(phone, otp) => {

    let url = `/api/verify-otp`;
    const response =  await fetch(url, {
        method: 'POST',
        body: JSON.stringify({"contactNumber": phone,"otp": parseInt(otp)}),
         headers: {
            'Content-Type': 'application/json',
        }
    });
    if (response.ok) {
        return await response.json();
        
    }
    throw response;
}


const setPasswordAction = async (phone, token, password) => {
    let url = `/api/set-password`;
    const response =  await fetch(url, {
        method: 'POST',
        body: JSON.stringify({"contactNumber": phone,"password": password}),
         headers: {
            'Content-Type': 'application/json',
            'x-access-token': token
        }
    });
    if (response.ok) {
        return await response.json();
        
    }
    throw response;
}
export { login, register, verifyOtp, setPasswordAction }